import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function RollerDiameterRow() {
   return (
      <InputRangeRow
         titleProp={"Roller Diameter"}
         descriptionProp={"mm"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={20.0}
         maxProp={200.0}
         propertyNameProp={"rollerDiameter"}
         errorDialogueProp={"20.0-200.0 only"}
         floatProp={true}
      />
   );
}
